"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationSchema = void 0;
const joi_1 = __importDefault(require("@hapi/joi"));
exports.PaginationSchema = joi_1.default
    .object({
    limit: joi_1.default.number().integer().positive(),
    offset: joi_1.default.number().integer().min(0),
    sort: joi_1.default.string(),
    direction: joi_1.default.string().valid('asc', 'desc'),
})
    .with('sort', 'direction')
    .with('direction', 'sort');
